export default {
  id: "settings",
  name: "Settings",
  shortName: "Settings",
  description: "Account, team & platform configuration",
  icon: "settings",
  color: "#6B7280",
  // Everyone gets the tile — Personal section is universal. Team / Workspace
  // / Platform sections are role-gated inside the app.
  roles: ["super_admin", "admin", "corporate", "franchisee", "marketing_agency"],
  css: "styles/apps/settings.css",
  // Internal sidebar handles nav; no top-bar nav.
  nav: [],
  defaultView: "profile",
};
